import type { IntegrationArticle } from '@/lib/site/seo/integration-content'

export const LOOPS_ARTICLE: IntegrationArticle = {
  sections: [
    {
      heading: 'Create editable drafts',
      paragraphs: [
        'Create an email in Brew, then export it as an editable campaign draft in Loops. In Brew, open Integrations → Loops → Setup and connect your Loops API key. Your Loops team needs Content API access and a configured sending domain.',
        'Open an email in Brew and choose Send → Export template → Loops. Check the name, subject and preview text, then choose Create draft. See draft opens the campaign in Loops.',
        'Review the converted layout, personalization, sender and audience in Loops before sending. Export creates a draft without sending or scheduling it, and does not copy contacts or audiences.',
      ],
    },
    {
      heading: 'Keep your Brew design with a ZIP',
      paragraphs: [
        'Choose Send → Export template → Loops ZIP to download your rendered design. You do not need a Loops connection in Brew for this option. ZIP downloads require a paid Brew plan.',
        'In the Loops email editor, choose Code styling and upload the ZIP. Confirm the subject and preview text, then preview the email in Loops. Images keep their public HTTPS URLs, so keep those hosted files available.',
        'Move stylesheet rules that reference html or body onto an inner table or container before downloading. Use plain CSS selectors. Brew rejects stylesheets it cannot safely preserve when MJML replaces the document shell.',
      ],
    },
    {
      heading: 'Choose the right export for your design',
      paragraphs: [
        'Editable drafts support text, headings, links, buttons, lists, static images and up to four columns. Layouts adapt to the Loops editor. Flat contact properties and simple fallback values transfer with the design.',
        'Nested cards become flat editable sections. Inner columns stack, wider rows split into groups, and table data stays editable. Decorative Brew textures use their fallback color; other background artwork becomes an image above its text. Review these layout changes in Loops, or use the ZIP to retain the rendered design.',
        'Content must fit Loops’ format and size limits. Unsupported personalization and image sources fail validation before creating a draft. Replace Brew personalization with Loops tags before downloading a ZIP.',
        'Loops adds its marketing footer to campaign drafts. Imported organization.name and organization.full_address placeholders in body text use that footer’s company details. Static address text and footer links stay in the design. Review the company details, unsubscribe link and final preview in Loops.',
      ],
    },
    {
      heading: 'Export from an agent or code',
      paragraphs: [
        'Use the export_email MCP tool or POST /v1/emails/{emailId}/export with provider set to loops. Both use the same brand connection as the app. The TypeScript SDK and CLI support the same export.',
        'Use dryRun: true to check the connection, content and images without creating a Loops draft. A successful dry run does not prove that Loops will accept a later write. ZIP download and upload are manual steps.',
      ],
    },
  ],
  sources: [
    {
      title: 'Loops export guide',
      url: 'https://docs.brew.new/integrations/export/loops',
    },
    {
      title: 'Loops API keys and Content API access',
      url: 'https://loops.so/docs/api-reference/api-key',
    },
    {
      title: 'Upload a custom email to Loops',
      url: 'https://loops.so/docs/creating-emails/uploading-custom-email',
    },
  ],
}
